export default __webpack_public_path__ + "static/media/Shaka_particle_final_01.ea7e2d93.png";